import { GET_LEAGUEPLAYERS_LOADING, GET_LEAGUEPLAYERS_SUCCESS, GET_LEAGUEPLAYERS_ERROR } from "../../../constant/actionTypes";
import { apiGet } from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";

export const getAllLeaguePlayers = () => (dispatch) => {
  dispatch({ type: GET_LEAGUEPLAYERS_LOADING });
  apiGet(
    `${ApiEndpoints.leaguePlayers.base}`,
    (response) => {
      if (response.error == true) {
        dispatch({ type: GET_LEAGUEPLAYERS_ERROR, response: response.message });
      } else {
        dispatch({ type: GET_LEAGUEPLAYERS_SUCCESS, response: response.data });
      }
    },
    (error) => {
      dispatch({ type: GET_LEAGUEPLAYERS_ERROR, response: error });
    }
  );
}